<template>
    <div class="container" style="margin-top: 100px;">
        <b-alert variant="success" class="col-lg-11 mt-5" v-if="createSuccess" dismissible @dismissed="createSuccess = false" show>Created email template successfully. This template will list in the saved template list after admin approval.</b-alert>
        <h5>Manage templates</h5>
        <nav area-label="breadcrumb" v-if="redirect_url">
            <ol class="breadcrumb px-0" style="font-size: 14px; background-color: #fff">
                <li class="breadcrumb-item"><a :href="redirect_url" style="color: #007bff8a;">Go back</a></li>
            </ol>
        </nav>
        <div class="d-flex align-items-center">
            <div class="col-6 d-flex justify-content-between">
                <b-input v-model="search" placeholder="Search templates"></b-input>
                <button class="btn btn-primary ml-3" @click="loadTemplates()">Search</button>
            </div>
            <div>
                <button class="btn btn-primary" @click="resetForm();$bvModal.show('create-template-modal')"><i class="mdi mdi-shape-square-plus menu-icon"></i>Create template</button>
            </div>
        </div>
        <div class="template row mt-5" v-if="templates.length">
           <div class="col-11 bg-white">
                <table class="table table-striped" style="white-space: nowrap" v-if="templates.length > 0">
                    <thead>
                        <tr>
                            <th>Template name</th>
                            <th>Created Time</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="template in templates" :key="template.tid">
                           <td>{{template.template_name}}</td>
                           <td>{{getDateWithTime(template.created_time)}}</td>
                           <td>{{getStatus(template.status)}}</td>
                            <td class="px-5" style="font-size: 1.25rem;width: max-content">
                                <span><i class="mdi mdi-eye" @click="showTemplate(template.tid)" v-b-tooltip.hover title="Preview"></i></span>
                                <span @click="deleteTemplate(template.tid)"><i class="mdi mdi-delete" v-b-tooltip.hover title="Delete"></i></span>
                                <span><i class="mdi mdi-pencil" @click="openEdit(template.tid)" v-b-tooltip.hover title="Edit"></i></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="templates.length">
                    <div class="col pl-6" >                                                      
                        showing results <span>{{ (page-1)*25 + 1 }}</span> - <span>{{ total > (page-1)*25 + 25  ? (page-1)*25 + 25 : total}}</span> of <span>{{total}}</span>
                    </div>
                    <div class="col pt-0">
                        <v-pagination
                        v-model="page"
                        :length="length"
                        class="float-left"
                        @input="handlePageChange"
                        ></v-pagination>
                    </div>
                </div>
                <div v-else>
                    <b-card>No templates found</b-card>
                </div>
           </div>
       </div>
       <b-modal id="create-template-modal" hide-footer title="Create email/sms communication alert" size="lg">
        <b-form>
            <b-form-group id="template_type" class="col-lg-6 mb-0">
                <label label-for="template_type" class="required">Type</label>
                <b-form-select class="pt-0" v-model="form.template_type" :options="template_type_options"></b-form-select>
                <div class="error-feedback" v-if="(typeof validate.response.template_type != undefined && can_post !=0 )">
                    {{ validate.response.template_type.msg }}
                </div>
            </b-form-group>
            <b-form-group id="template_name" class="col-lg-12 mb-0">
                <label label-for="template_name" class="required">Template name</label>
                <b-form-input id="template_name" v-model="form.template_name"  trim></b-form-input>
                <div class="error-feedback" v-if="(typeof validate.response.template_name != undefined && can_post !=0 )">
                    {{ validate.response.template_name.msg }}
                </div>
            </b-form-group>
            <b-form-group id="subject" class="col-lg-12 mb-0">
                <label label-for="subject" class="required">Subject line</label>
                <b-form-input id="subject" v-model="form.subject" trim></b-form-input>
                <div class="error-feedback" v-if="(typeof validate.response.subject != undefined && can_post !=0 )">
                    {{ validate.response.subject.msg }}
                </div>
            </b-form-group>
            <b-form-group id="body" class="col-lg-12 mb-0">
                <label label-for="body" class="required">Body</label>
                <vue-editor v-model="form.body" :editorToolbar="customToolbar" class="editor"></vue-editor>
                <div class="error-feedback" v-if="(typeof validate.response.body != undefined && can_post !=0 )">
                    {{ validate.response.body.msg }}
                </div>
            </b-form-group>
        </b-form>
        <div class="col-lg-12 d-flex justify-content-between">
            <div class="col-3">Select keywords</div>
            <div class="row col-9">
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ candidate_name }}')" v-html="'{{ Candidate name }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ job_id }}')" v-html="'{{ Job id }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ client_name }}')" v-html="'{{ Client Name }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ job_location }}')" v-html="'{{ Job location }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ job_designation }}')" v-html="'{{ Job designation }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ recruiter_name }}')" v-html="'{{ Recruiter name }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ recruiter_email }}')" v-html="'{{ Recruiter email }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ application_status }}')" v-html="'{{ Application status }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ job_title }}')" v-html="'{{ Job title }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ job_salary }}')" v-html="'{{ Job salary }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ course }}')" v-html="'{{ Course }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ last_date_to_apply }}')" v-html="'{{ Last date to apply }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ job_description }}')" v-html="'{{ Job description }}'"></button>
                <button class="btn btn-outline-secondary mr-1 mb-3" @click="appendKeyword('{{ apply_link }}')" v-html="'{{ Link to apply }}'"></button>
            </div>
        </div>
        <div class="col d-flex justify-content-end">
            <b-button class="btn btn-primary mr-3" v-b-modal.template-preview>Preview</b-button>
            <b-button class="btn btn-primary" @click="createTemplate()" v-if="!isEdit">Save</b-button>
            <b-button class="btn btn-primary" @click="updateTemplate()" v-else>Update</b-button>
        </div>
       </b-modal>
        <b-modal id="template-preview" title="Template preview" hide-footer size="lg">
            <div>
                <p class="mb-0"><strong>Subject:</strong></p>
                <p>{{form.subject}}</p>
                <div v-if="form.template_type == 1">
                    <p class="mb-0 mt-3"><strong>Mail content:</strong></p>
                    <EmailPreview :body="form.body"/>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { VueEditor} from "vue2-editor/dist/vue2-editor.core.js";
const EmailPreview = () => import(/* webpackPrefetch: true */ "@/components/EmailPreview");

export default {
    name: 'manage_templates',
    components: {
        VueEditor,
        EmailPreview
    },
    beforeMount() {
       this.token = this.$cookies.get("hire-employer").token;
       this.loadTemplates();
       if(this.$route.query.redirect_to) this.redirect_url = this.$route.query.redirect_to
    },
    data(){
        return {
            form: {
                template_type: 1,
                template_name: '',
                subject: '',
                body: '',
            },
            redirect_url: '',
            customToolbar: [
                ["bold", "italic", "underline"], 
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: "" },{ align: "center" },{ align: "right" },{ align: "justify" }],
            ],
            validate: new this.$valid(),
            can_post: 0,
            template_type_options: [
                { value: 1, text: "Mail" },
                { value: 2, text: "SMS" },
            ],
            token: null,
            templates: [],
            isEdit: false,
            template_on_edit: null,
            length: 0,
            page:1,
            offset: 0,
            limit: 25,
            total: 0,
            params:'',
            search: '',
            createSuccess: false
        }
    },
    methods: {
        appendKeyword: function(keyword) {
            this.form.body += keyword;
            console.log(this.form.body)
        },
        validationCheck: function(){
            if(this.validate.checkIfEmpty(this.form.template_name, "template_name", 'Choose a name for your template')?.val === false){
                this.can_post++;
            }
            if(this.validate.checkIfEmpty(this.form.template_type, "template_type", 'Choose a template type')?.val === false){
                this.can_post++;
            }
            if(this.validate.checkIfEmpty(this.form.subject, "subject", 'Add a subject')?.val === false){
                this.can_post++;
            }
            if(this.validate.checkIfEmpty(this.form.body, "body", 'Add a template body')?.val === false){
                this.can_post++;
            }
        },
        handlePageChange(value) {
            this.page = value;
            this.offset = this.limit * (this.page - 1);
            this.loadTemplates()
        },
        resetForm: function(){
            this.isEdit = false;
            this.form.template_type = 1;
            this.form.template_name = '';
            this.form.subject = '';
            this.form.body = '';
            this.can_post = 0;
            this.createSuccess = false;
        },
        createTemplate: function(){
            this.can_post = 0;
            this.createSuccess = false;
            this.validationCheck();
            if(this.can_post == 0){
                new this.$apiAction().createTemplate(this.form, this.token).then((res) => {
                    if(res.status) {
                        this.resetForm();
                        this.$bvModal.hide('create-template-modal');
                        this.$bvModal.hide('template-preview');
                        this.loadTemplates();
                        this.createSuccess = true;
                    }
                }).catch((err) => {
                    console.log(err)
                });
            }
        },
        deleteTemplate: function(id) {
            new this.$apiAction().deleteTemplate(id, this.token).then((res) => {
                    if(res.status == true) {
                    this.loadTemplates();
                }
            }).catch((err) => {
                console.log(err)
            });
        },
        loadTemplates: function(){
            this.params = '';
            // let params = '';
            this.params += '?offset='+ this.offset;
            if(this.search) this.params += '&search='+ this.search;
            new this.$apiAction().getTemplates(this.token, this.params).then((res) => {
                console.log(res);
                if(res.meta.success) {
                    this.templates = res.templates;
                    this.limit = res.meta.limit;
                    this.offset = res.meta.offset;
                    this.total = res.meta.total;
                    this.length = Math.ceil(res.meta.total/res.meta.limit);
                }
            }).catch((err) => {
                console.log(err)
            });
        },
        showTemplate(id) {
            new this.$apiAction().showTemplate(id, this.token).then((res) => {
                // this.form =  res.template;
                this.form.template_name = res.template.template_name;
                this.form.template_type = res.template.template_type;
                this.form.subject = res.template.subject;
                this.form.body = res.template.body;
                this.$bvModal.show('template-preview');

            }).catch((err) => {
                console.log(err)
            });
        },
        openEdit(id) {
            this.isEdit = true;
            this.template_on_edit = id;
            new this.$apiAction().showTemplate(id, this.token).then((res) => {
                this.form.template_name = res.template.template_name;
                this.form.template_type = res.template.template_type;
                this.form.subject = res.template.subject;
                this.form.body = res.template.body;
                this.$bvModal.show('create-template-modal');

            }).catch((err) => {
                console.log(err)
            });
        },
        getStatus(status) {
            switch(status) {
                case 0: return 'Pending'; 
                case 1: return 'Active'; 
                default: break;
            }
        },
        updateTemplate(){
            this.can_post = 0;
            this.validationCheck();
            if(this.can_post == 0){
                new this.$apiAction().updateTemplate(this.form, this.template_on_edit, this.token).then((res) => {
                    if(res.status){
                        this.$bvModal.hide('create-template-modal');
                        this.$bvModal.hide('template-preview');
                        this.loadTemplates();
                    } else {
                        console.log("err=>", res)
                    }
                }).catch((err) => {
                    console.log(err)
                });
            }
        },
        updateStatus(id, status) {
            new this.$apiAction().updateTemplateStatus(id, status, this.token).then((res) => {
                    if(res.status == true) {
                    this.loadTemplates();
                }
            }).catch((err) => {
                console.log(err)
            });
        },
        getDateWithTime(ts) {
            var timestamp = ts * 1000;
            var date = new Date(timestamp);
            return date.getDate()+
                "-"+(date.getMonth()+1)+
                "-"+date.getFullYear()+
                " "+date.getHours()+
                ":"+date.getMinutes()+
                ":"+date.getSeconds()
        },
    }
    
}
</script>
<style>
    @import "~vue2-editor/dist/vue2-editor.css";

    /* Import the Quill styles you want */
    @import '~quill/dist/quill.core.css';
    @import '~quill/dist/quill.bubble.css';
    @import '~quill/dist/quill.snow.css';
   
    .note-editor{
        background-color: #E4E4E4 !important;
    }
    .note-btn{
        background-color: #fff !important;
        border: 1px solid #afafaf !important;
        height: 30px !important;
        margin: 0.1rem;
    }
    .note-btn:hover{
        background-color: #e9e9e9 !important;
    }
    .editor{
        background-color: #fff;
    }
    .truncate-words{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
    label.required::after {
        content: "*";
        color:red;
        font-size: 1.25rem;
        margin-left: 0.15rem;
    }
    .template .table th, .template .table td {
        text-align: start !important;
    }
</style>